// @flow
import { memo, useState, useCallback } from 'react'
import cx from 'classnames'
import { Icon } from '@foxford/ui/es/components/Icon/Icon'

import css from './Accordeon.sass'

type AccordeonProps = {|
  children: React$Node,
  heading?: string,
  className?: string,
|}

export const Accordeon = memo<AccordeonProps>(({ children, heading = '', className = '' }: AccordeonProps) => {
  const [isActive, setStateActive] = useState(false)

  const onClick = useCallback(() => {
    setStateActive(!isActive)
  }, [isActive])

  return (
    <div className={cx(css.root, className, isActive && css.active)}>
      <div className={css.trigger} onClick={onClick}>
        <span className={css.triggerText}>{heading}</span>
        <Icon className={css.arrow} name='dropDownArrow' />
      </div>
      <div className={css.content}>{children}</div>
    </div>
  )
})
